import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton", "submitIcon", "submitLoadingIcon"]

  connect() {
    this.isLoading = false
    this.element.addEventListener("submit", this.handleSubmit)
  }

  disconnect() {
    this.element.removeEventListener("submit", this.handleSubmit)
  }

  handleSubmit = (e) => {
    this.toggleIsLoading()
  }

  toggleIsLoading() {
    this.isLoading = !this.isLoading
    this.submitButtonTarget.disabled = this.isLoading

    if (this.isLoading) {
      this.submitIconTarget.classList.add("hidden")
      this.submitLoadingIconTarget.classList.remove("hidden")
    } else {
      this.submitIconTarget.classList.remove("hidden")
      this.submitLoadingIconTarget.classList.add("hidden")
    }
  }
}
